/**
 * Handles the setting of a sharpspring script.
 * @function
 * @param {string} siteHandle - Site handle (e.g. be-NL)
 * @param {string} sharpspringScriptUrl - Script URL for the Sharpspring script.
 */
export function handleLoadSharpsringScriptUrl(
    siteHandle,
    sharpspringScriptUrl,
) {
    const isNotBelux =
        siteHandle !== 'mgMotorsBelgiumNl' &&
        siteHandle !== 'mgMotorsBelgiumFr' &&
        siteHandle !== 'mgMotorsLuxembourgFr';
    if (isNotBelux) return;
    const shaprspringScript = document.createElement('script');
    shaprspringScript.setAttribute('src', sharpspringScriptUrl);
    document.body.appendChild(shaprspringScript);
}
